import { axios } from '../utilities';

const getPrompts = (types = []) => axios.post('api/prompts', { types });

const savePrompt = (prompt) => axios.put('api/prompts/save-prompt', { prompt });

export default {
  getPrompts,
  savePrompt,
};
